import { ref, reactive, toRefs } from '@nuxtjs/composition-api';
import { VALIDATION_STATUS } from '~/constants/ValidationStatus';
export default function useNumberPorting (appContext) {
  const hubbleClient = appContext.$hubble;
  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  // const { $hubble } = useContext()
  const teleOperatorInfo = ref({})
  const iccState = reactive({
    iccValid: false,
    iccErrors: [],
    iccMessages: [],
    iccLoading: false
  })
  const ochState = reactive({
    ochValid: false,
    ochErrors: [],
    ochMessages: [],
    ochLoading: false
  })
  const validateMobileNumber = async (mobileNumber) => {
    ochState.ochErrors = []
    ochState.ochMessages = []

    ochState.ochLoading = true
    ochState.ochMessages = ['Vent venligst, mens vi kontrollerer dit mobilnummer']
    teleOperatorInfo.value = {}

    const res = await hubbleClient.checkout.validateMobileNumber(mobileNumber)

    if (res.data.actionStatus !== VALIDATION_STATUS.ERROR) {
      teleOperatorInfo.value = res.data.responseObject
      ochState.ochValid = true
      ochState.ochErrors = []
    } else {
      const actionErrors = res.data.actionErrors
      if (actionErrors.length > 0) {
        if (actionErrors.find(notification => notification.notificationCode === '0300-0015') !== undefined) {
          ochState.ochErrors = ['Vi kan desværre ikke hjælpe dig online pt., prøv enten senere eller kontakt venligst kunderservice på tlf. 70218900']
        } else {
          ochState.ochErrors = ['Telefonnummeret kan desværre ikke flyttes, kontakt evt. kundeservice på tlf. 70218900']
        }
      }
      ochState.ochValid = false
    }
    ochState.ochLoading = false
    ochState.ochMessages = []

    return res.data.responseObject
  }
  const validateIcc = async(cps, icc) => {
    iccState.iccErrors = []
    iccState.iccMessages = []

    iccState.iccLoading = true
    iccState.iccMessages = ['Vent venligst, mens vi kontrollerer dit SIM-kortnummer']

    const res = await hubbleClient.checkout.validateIcc(cps, icc)
    if (res.data.responseObject) {
      iccState.iccValid = true
      iccState.iccErrors = []
    } else {
      iccState.iccValid = false
      iccState.iccErrors = ['SIM-kortnummeret du har indtastet er ikke gyldigt. Prøv venligst igen.']
    }
    iccState.iccLoading = false
    iccState.iccMessages = []

    return res.data.responseObject
  }
  return {
    ...toRefs(iccState),
    ...toRefs(ochState),
    teleOperatorInfo,
    validateIcc,
    validateMobileNumber
  }
}
